import { type FCC } from 'types';
import styles from './TooltipWrapper.module.scss';

interface TooltipWrapperProps {
  toggle: boolean;
  content: string | undefined;
  id?: string;
}

const TooltipWrapper: FCC<TooltipWrapperProps> = (props) => {
  const { children, toggle, content, id } = props;

  return (
    <>
      {children}
      {toggle && content && (
        <div className={styles.tooltip} id={id} role="tooltip">
          <p className={styles.tooltipText}>{content}</p>
        </div>
      )}
    </>
  );
};

export default TooltipWrapper;
